import type Lenis from 'lenis';

// Shared holder for the active Lenis instance so non-component code (the router's
// scrollBehavior, the hash-scroll plugin) can drive scrolling through Lenis.
// When Lenis is inactive (SSR or prefers-reduced-motion) this stays null and
// callers fall back to native scrolling.
let lenisInstance: Lenis | null = null;

export const setLenis = (instance: Lenis | null) => {
  lenisInstance = instance;
};

export const getLenis = (): Lenis | null => lenisInstance;
